import { createInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import mocki18n from 'tests/mocki18n';

const setupI18n = () => {
  const i18n = createInstance();

  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      load: 'all',
      backend: {
        loadPath: `${
          process.env.NODE_ENV !== 'production' || !!process.env.REACT_APP_IS_CYPRESS_TEST
            ? process.env.TQ_HOST_URL || `http://localhost:${process.env.TQ_PORT || `3003`}`
            : `https://%TQ_HOST_URL%`
        }/locales/{{lng}}/translation.json`,
      },
      lng: 'en-US',
      fallbackLng: 'en-US',
      debug: true,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    });

  return i18n;
};

const i18n = process.env.NODE_ENV === 'test' ? mocki18n : setupI18n();

export default i18n;
